
interface SanityImageOptions {
    width?: number
    height?: number
    fit?: string
    crop?: string
    quality?: number
    format?: string
    auto?: string
    blur?: number
    rect?: string
}


export const GetSanityImageUrl = (url: string, options?: SanityImageOptions): string => {

    try {
        const urlObj = new URL(url);

        const defaultWidth = options?.width || urlObj.searchParams.get('w') || 800
        const defaultFormat = options?.format || urlObj.searchParams.get('fm') || 'webp'
        const defaultQuality = options?.quality || urlObj.searchParams.get('q') || 75

        urlObj.searchParams.set('fm', defaultFormat);
        urlObj.searchParams.set('q', `${defaultQuality}`);
        urlObj.searchParams.set('w', `${defaultWidth}`);

        if (options?.height) urlObj.searchParams.set('h', `${options.height}`);
        if (options?.fit) urlObj.searchParams.set('fit', options.fit);
        if (options?.crop) urlObj.searchParams.set('crop', options.crop);
        if (options?.auto) urlObj.searchParams.set('auto', options.auto);
        if (options?.blur) urlObj.searchParams.set('blur', `${options.blur}`);
        if (options?.rect) {
            const rect = options.rect.split(',').map(Number);
            if (rect.length === 4) {
                urlObj.searchParams.set('rect', `${rect[0]},${rect[1]},${rect[2]},${rect[3]}`);
            }
        }

        return urlObj.toString();
    } catch (err) {
        console.warn('Invalid URL provided to getSanityImageUrl:', url);
        return url; // fallback to original if invalid
    }
}
